'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactIdSwiper = require('react-id-swiper');var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
var _ProjectInlineGallery = require('./ProjectInlineGallery.scss');var styles = _interopRequireWildcard(_ProjectInlineGallery);
var _galleryParams = require('../../../galleryParams');var _galleryParams2 = _interopRequireDefault(_galleryParams);
var _constants = require('../../../constants');
var _modifyImageLink = require('../../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

ProjectInlineGallery = function (_Component) {_inherits(ProjectInlineGallery, _Component);function ProjectInlineGallery() {var _temp, _this, _ret;_classCallCheck(this, ProjectInlineGallery);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      index: 0 }, _this.




















    resizeThrottler = function () {return _this.swiperRef.swiper.resize.resizeHandler();}, _this.

    slideChange = function () {
      if (_this.swiperRef) {
        var index = _this.swiperRef.swiper.activeIndex;
        _this.setState({ index: index });
      }
    }, _this.

    openLightbox = function (index) {return function () {return !_this.props.noLightbox && _this.props.openLightbox(index);};}, _this.

    renderImage = function (_ref, index) {var full = _ref.full;return (
        _react2.default.createElement('div', {
            key: full,
            className: styles.image },

          _react2.default.createElement('img', {
            alt: '',
            src: (0, _modifyImageLink2.default)(full, _constants.imageModifierTypes.PROJECT_DETAILS),
            onClick: _this.openLightbox(index) }),

          _react2.default.createElement('div', { className: styles.fullScreenButton }, _react2.default.createElement('span', { className: 'icon icon-expand' }))));}, _temp), _possibleConstructorReturn(_this, _ret);}ProjectInlineGallery.prototype.componentDidMount = function componentDidMount() {if (this.props.isMobile && !this.props.noLightbox) {window.addEventListener('orientationchange', this.resizeThrottler, false);}};ProjectInlineGallery.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {if (this.props.isMobile && !this.props.noLightbox && !newProps.isLightboxOpen && this.props.isLightboxOpen) {this.resizeThrottler();}};ProjectInlineGallery.prototype.componentWillUnmount = function componentWillUnmount() {if (this.props.isMobile && !this.props.noLightbox) {window.removeEventListener('orientationchange', this.resizeThrottler, false);}};ProjectInlineGallery.prototype.


  render = function render() {var _this2 = this;var _props =
    this.props,images = _props.images,isRtl = _props.isRtl,isMobile = _props.isMobile;
    var quantity = images.length;

    var gallerySwiperParams = (0, _galleryParams2.default)({
      className: 'projectsGallery',
      isMobile: isMobile,
      isRtl: isRtl });


    var params = Object.assign({},
    gallerySwiperParams, {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false },

      pagination: {
        el: '.swiper-pagination',
        type: 'fraction' },

      paginationCustomizedClass: styles.quantityTitle,
      loop: images.length > 1,
      noSwiping: images.length <= 1 });


    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement('div', { className: styles.galleryWrapper },
          _react2.default.createElement(_reactIdSwiper2.default, _extends({},
            params, {
              on: { slideChange: this.slideChange },
              ref: function ref(_ref2) {_this2.swiperRef = _ref2;},
              noSwiping: quantity <= 1 }),

            images.map(this.renderImage)))));




  };return ProjectInlineGallery;}(_react.Component);exports.default = ProjectInlineGallery;


ProjectInlineGallery.propTypes = {
  images: _propTypes2.default.array,
  openLightbox: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  noLightbox: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  isLightboxOpen: _propTypes2.default.bool.isRequired };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/ProjectInlineGallery/ProjectInlineGallery.js
// module id = 2832
// module chunks = 0